import { render } from "./AvalonTemplate.vue?vue&type=template&id=3794261c"
import script from "./AvalonTemplate.vue?vue&type=script&lang=js"
export * from "./AvalonTemplate.vue?vue&type=script&lang=js"

import "./AvalonTemplate.vue?vue&type=style&index=0&id=3794261c&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__